export default {
  "2006": [
    "Albany (South West)",
    "Alfred Cove (South Metropolitan)",
    "Armadale (East Metropolitan)",
    "Avon (Agricultural)",
    "Balcatta (North Metropolitan)",
    "Ballajura (East Metropolitan)",
    "Bassendean (East Metropolitan)",
    "Belmont (East Metropolitan)",
    "Bunbury (South West)",
    "Capel (South West)",
    "Carine (North Metropolitan)",
    "Central Kimberley - Pilbara (Mining And Pastoral)",
    "Churchlands (North Metropolitan)",
    "Cockburn (South Metropolitan)",
    "Collie - Wellington (South West)",
    "Cottesloe (North Metropolitan)",
    "Darling Range (East Metropolitan)",
    "Dawesville (South West)",
    "Fremantle (South Metropolitan)",
    "Geraldton (Agricultural)",
    "Girrawheen (North Metropolitan)",
    "Greenough (Agricultural)",
    "Hillarys (North Metropolitan)",
    "Jarrahdale - Serpentine (East Metropolitan)",
    "Joondalup (North Metropolitan)",
    "Kalgoorlie (Mining And Pastoral)",
    "Kenwick (East Metropolitan)",
    "Kimberley (Mining And Pastoral)",
    "Kingsley (North Metropolitan)",
    "Leschenault (South West)",
    "Mandurah (South West)",
    "Maylands (North Metropolitan)",
    "Merredin (Agricultural)",
    "Midland (East Metropolitan)",
    "Mindarie (North Metropolitan)",
    "Moore (Agricultural)",
    "Murchison - Eyre (Mining And Pastoral)",
    "Murdoch (South Metropolitan)",
    "Murray (South West)",
    "Nedlands (North Metropolitan)",
    "North West Coastal (Mining And Pastoral)",
    "Peel (South Metropolitan)",
    "Perth (North Metropolitan)",
    "Riverton (South Metropolitan)",
    "Rockingham (South Metropolitan)",
    "Roe (Agricultural)",
    "South Perth (South Metropolitan)",
    "Southern River (East Metropolitan)",
    "Stirling (South West)",
    "Swan Hills (East Metropolitan)",
    "Vasse (South West)",
    "Victoria Park (South Metropolitan)",
    "WA No Usual Address",
    "WA Not applicable",
    "Wagin (Agricultural)",
    "Wanneroo (North Metropolitan)",
    "Warren - Blackwood (South West)",
    "Willagee (South Metropolitan)",
    "Yokine (North Metropolitan)"
  ],
  "2011": [
    "Albany (South West)",
    "Alfred Cove (South Metropolitan)",
    "Armadale (East Metropolitan)",
    "Bassendean (East Metropolitan)",
    "Belmont (East Metropolitan)",
    "Gosnells (East Metropolitan)",
    "Kalamunda (East Metropolitan)",
    "Kalgoorlie (Mining And Pastoral)",
    "Kimberley (Mining And Pastoral)",
    "Kwinana (South Metropolitan)",
    "Mandurah (South West)",
    "Maylands (East Metropolitan)",
    "Midland (East Metropolitan)",
    "Mindarie (North Metropolitan)",
    "Moore (Agricultural)",
    "Mount Lawley (East Metropolitan)",
    "Murray-Wellington (South West)",
    "Nedlands (North Metropolitan)",
    "North West (Mining And Pastoral)",
    "Ocean Reef (North Metropolitan)",
    "Perth (North Metropolitan)",
    "Pilbara (Mining And Pastoral)",
    "Riverton (South Metropolitan)",
    "Rockingham (South Metropolitan)",
    "South Perth (South Metropolitan)",
    "Swan Hills (East Metropolitan)",
    "Vasse (South West)",
    "Victoria Park (South Metropolitan)",
    "Wagin (Agricultural)",
    "Warnbro (South Metropolitan)",
    "West Swan (East Metropolitan)",
    // "No usual address (WA)",
    "Migratory - Offshore - Shipping (WA)",
    "Blackwood-Stirling (South West)",
    "Bunbury (South West)",
    "Balcatta (North Metropolitan)",
    "Bateman (South Metropolitan)",
    "Cannington (South Metropolitan)",
    "Carine (North Metropolitan)",
    "Central Wheatbelt (Agricultural)",
    "Churchlands (North Metropolitan)",
    "Cockburn (South Metropolitan)",
    "Collie-Preston (South West)",
    "Cottesloe (North Metropolitan)",
    "Darling Range (East Metropolitan)",
    "Dawesville (South West)",
    "Eyre (Mining And Pastoral)",
    "Forrestfield (East Metropolitan)",
    "Fremantle (South Metropolitan)",
    "Geraldton (Agricultural)",
    "Girrawheen (North Metropolitan)",
    "Hillarys (North Metropolitan)",
    "Jandakot (South Metropolitan)",
    "Joondalup (North Metropolitan)",
    "Kingsley (North Metropolitan)",
    "Morley (East Metropolitan)",
    "Nollamara (East Metropolitan)",
    "Scarborough (North Metropolitan)",
    "Southern River (South Metropolitan)",
    "Wanneroo (North Metropolitan)",
    "Willagee (South Metropolitan)"
  ],
  "2016": [
    "Albany (South West)",
    "Armadale (East Metropolitan)",
    "Balcatta (North Metropolitan)",
    "Baldivis (South Metropolitan)",
    "Bassendean (East Metropolitan)",
    "Bateman (South Metropolitan)",
    "Belmont (East Metropolitan)",
    "Bicton (South Metropolitan)",
    "Bunbury (South West)",
    "Burns Beach (North Metropolitan)",
    "Butler (North Metropolitan)",
    "Cannington (South Metropolitan)",
    "Carine (North Metropolitan)",
    "Central Wheatbelt (Agricultural)",
    "Churchlands (North Metropolitan)",
    "Cockburn (South Metropolitan)",
    "Collie-Preston (South West)",
    "Cottesloe (North Metropolitan)",
    "Darling Range (East Metropolitan)",
    "Dawesville (South West)",
    "Forrestfield (East Metropolitan)",
    "Fremantle (South Metropolitan)",
    "Geraldton (Agricultural)",
    "Girrawheen (North Metropolitan)",
    "Hillarys (North Metropolitan)",
    "Jandakot (South Metropolitan)",
    "Joondalup (North Metropolitan)",
    "Kalamunda (East Metropolitan)",
    "Kalgoorlie (Mining and Pastoral)",
    "Kimberley (Mining and Pastoral)",
    "Kingsley (North Metropolitan)",
    "Kwinana (South Metropolitan)",
    "Mandurah (South West)",
    "Maylands (East Metropolitan)",
    "Midland (East Metropolitan)",
    "Migratory - Offshore - Shipping (WA)",
    "Mirrabooka (East Metropolitan)",
    "Moore (Agricultural)",
    "Morley (East Metropolitan)",
    "Mount Lawley (East Metropolitan)",
    "Murray-Wellington (South West)",
    "Nedlands (North Metropolitan)",
    "No usual address (WA)",
    "North West Central (Mining and Pastoral)",
    "Perth (North Metropolitan)",
    "Pilbara (Mining and Pastoral)",
    "Riverton (South Metropolitan)",
    "Rockingham (South Metropolitan)",
    "Roe (Agricultural)",
    "Scarborough (North Metropolitan)",
    "South Perth (South Metropolitan)",
    "Southern River (South Metropolitan)",
    "Swan Hills (East Metropolitan)",
    "Thornlie (East Metropolitan)",
    "Vasse (South West)",
    "Victoria Park (South Metropolitan)",
    "Wanneroo (North Metropolitan)",
    "Warnbro (South Metropolitan)",
    "Warren-Blackwood (South West)",
    "West Swan (East Metropolitan)",
    "Willagee (South Metropolitan)"
  ],
  "2021": [
    "Albany (South West)",
    "Armadale (East Metropolitan)",
    "Balcatta (North Metropolitan)",
    "Baldivis (South Metropolitan)",
    "Bassendean (East Metropolitan)",
    "Bateman (South Metropolitan)",
    "Belmont (East Metropolitan)",
    "Bicton (South Metropolitan)",
    "Bunbury (South West)",
    "Burns Beach (North Metropolitan)",
    "Butler (North Metropolitan)",
    "Cannington (South Metropolitan)",
    "Carine (North Metropolitan)",
    "Central Wheatbelt (Agricultural)",
    "Churchlands (North Metropolitan)",
    "Cockburn (South Metropolitan)",
    "Collie-Preston (South West)",
    "Cottesloe (North Metropolitan)",
    "Darling Range (East Metropolitan)",
    "Dawesville (South West)",
    "Forrestfield (East Metropolitan)",
    "Fremantle (South Metropolitan)",
    "Geraldton (Agricultural)",
    "Hillarys (North Metropolitan)",
    "Jandakot (South Metropolitan)",
    "Joondalup (North Metropolitan)",
    "Kalamunda (East Metropolitan)",
    "Kalgoorlie (Mining and Pastoral)",
    "Kimberley (Mining and Pastoral)",
    "Kingsley (North Metropolitan)",
    "Kwinana (South Metropolitan)",
    "Landsdale (North Metropolitan)",
    "Mandurah (South West)",
    "Maylands (East Metropolitan)",
    "Midland (East Metropolitan)",
    "Migratory - Offshore - Shipping (WA)",
    "Mirrabooka (East Metropolitan)",
    "Moore (Agricultural)",
    "Morley (East Metropolitan)",
    "Mount Lawley (East Metropolitan)",
    "Murray-Wellington (South West)",
    "Nedlands (North Metropolitan)",
    "No usual address (WA)",
    "North West Central (Mining and Pastoral)",
    "Perth (North Metropolitan)",
    "Pilbara (Mining and Pastoral)",
    "Riverton (South Metropolitan)",
    "Rockingham (South Metropolitan)",
    "Roe (Agricultural)",
    "Scarborough (North Metropolitan)",
    "South Perth (South Metropolitan)",
    "Southern River (South Metropolitan)",
    "Swan Hills (East Metropolitan)",
    "Thornlie (East Metropolitan)",
    "Vasse (South West)",
    "Victoria Park (South Metropolitan)",
    "Wanneroo (North Metropolitan)",
    "Warnbro (South Metropolitan)",
    "Warren-Blackwood (South West)",
    "West Swan (East Metropolitan)",
    "Willagee (South Metropolitan)",    
  ]
};



// WEBPACK FOOTER //
// ../data/wa/electoral_districts.js